export const locale = {
  base: {
    exportData: 'Експорт даних',
    general: 'Загальне',
    aprove: 'Затвердити',
    subscribe: 'Підписатися',
    unsubscribe: 'Відписатися',
    toSubscriptions: 'До підписок',
    subscribtions: 'Підписки',
    colleagues: 'Колеги',
    search: 'Пошук',
    doNotMiss: 'Не пропустіть сьогодні',
    searchMain: 'Пошук новин, співробітників, документів, подій',
    emptyList: 'Порожній список',
    publish: 'Опублікувати',
    unlock: 'Розблокувати',
    published: 'Опублікувати',
    rejected: 'Відхилити',
    send: 'Відправити',
    saveAsDraft: 'Зберегти у чернетки',
    save: 'Зберегти',
    select: 'Вибрати',
    noData: 'Немає даних',
    toMain: 'На головну',
    myArticles: 'Мої публікації',
    myDrafts: 'Мої чернетки',
    exit: 'Вийти',
    edit: 'Редагувати',
    delete: 'Видалити',
    close: 'Закрити',
    leave: 'Залишити',
    more: 'Ще',
    add: 'Додати',
    showMore: 'Показати ще',
    hideMore: 'Приховати',
    answer: '0 відповідей | {n} відповідь | {n} відповіді | {n} відповідей',
    category: '0 категорій | {n} категорія | {n} категорії | {n} категорій',
    clustery: '0 регіонів | {n} регіонів | {n} регіонів | {n} регіонів',
    user: '0 користувачів | {n} користувач | {n} користувачі | {n} користувачів',
    categories: 'Категорії',
    clusters: 'Регіони',
    clusterOne: 'Регіон',
    categoryOne: 'Категорія',
    answered: 'Відповів',
    upload: 'Завантажити',
    uploadFile: 'Завантажити файл',
    uploadImg: 'Завантаження зображення',
    supportedFormats: 'Допустимі формати: {value}.',
    maxFileSize: 'Максимальний розмір: {value}МБ',
    supportedSize: 'Розширення: {value}.',
    minimumResolution: 'Мінімальна роздільна здатність: {value}.',
    fileUploaded: 'Файл завантажено',
    yes: 'Так',
    no: 'Ні',
    maybe: 'Можливо',
    join: 'Приєднатися',
    tune: 'Налаштувати',
    result: 'Результат',
    congratulate: 'Привітати',
    congratulation: 'Привітання',
    actions: 'Дії',
    commentOrigin: 'Коментар',
    writeComment: 'Написати коментар...',
    department: 'департамент',
    create: 'Створити',
    articleModerationEnabled: 'Модерація новин',
    cancel: 'Скасувати',
    cancel2: 'Анулювати',
    comment: '0 Коментарів | {n} Коментар | {n} Коментарі | {n} Коментарів',
    seeComments: 'Показати інші коментарі',
    reply: 'Відповісти',
    myProfile: 'Мій профіль',
    profileSetting: 'Налаштування профілю',
    companyStructure: 'Структура компанії',
    businessTrips: 'Відрядження',
    portal: 'Портал',
    adminPanel: 'Адмін панель',
    never: 'Ніколи',
    date: 'Дата',
    time: 'Час',
    after: 'Після',
    liked: 'Оцінили',
    selectDate: 'Виберіть дату',
    times: 'раз',
    subTitleDocuments: 'Підзаголовок для документів',
    subTitle: 'підзаголовок',
    sizes: ['Байт', 'КБ', 'МБ', 'ГБ'],
    cluster: 'Регіон',
    timezoneInfo: 'Час відображається у часовому поясі Europe GMT +3:00',
    saveData: 'Дані успішно збережено',
    icons: 'Іконки',
    icon: 'Іконка',
    share: 'Поділитися',
    enterName: 'Введіть назву',
    sum: 'Сума',
    currency: 'Валюта',
    rate: 'Курс',
    noItemsByParams: 'За заданими параметрами нічого не знайдено',
    deleteNotAvailable: 'Видалити неможливо – елемент уже використовується.',
    byDefault: 'За замовчуванням',
    others: 'Інше',
    ok: 'Добре',
    filter: 'Фільтр',
    filters: 'Фільтри',
    apply: 'Застосувати',
    clear: 'Очистити',
    enterLocation: 'Введіть місце розташування'
  },
  correspondence: {
    date: 'Дата',
    sender: 'Відправник',
    number: 'Номер',
    signatory: 'Підписант',
    initiator: 'Ініціатор',
    correspondenceType: 'Тип',
    documentType: 'Тип документу',
    deliveryType: 'Спосіб відправлення',
    shortContent: 'Короткий зміст',
    recipient: 'Отримувач',
    address: 'Адреса доставки',
    cost: 'Вартість відправлення',
    currency: 'Валюта',
    comment: 'Коментар',
    input: 'Вхідна',
    output: 'Вихідна',
    in: ' в',
  },
  subscribe: {
    successNewsTitle: 'Ви підписалися на новини {name}',
    successNewsDescription: 'Повідомлення про нові публікації користувача {name} будуть надходити Вам на пошту.',
  },
  lang: {
    ru: 'Російська',
    en: 'Англійська',
    ka: 'Грузинська',
    ua: 'Українська',
  },
  actions: {
    create: 'Створення',
    remove: 'Видалення',
    update: 'Редагування',
  },
  settings: {
    articleModerationEnabled: {
      true: 'Активний',
      false: 'Неактивний',
    },
  },
  createUser: {
    form: {
      firstName: 'Ім\'я',
      lastName: 'Фамілія',
      email: 'Email',
      password: 'Пароль',
      country: 'Країна',
      company: 'Компанія',
    },
    placeholder: {
      firstName: 'Введіть ім\'я',
      lastName: 'Введіть фамілію',
      email: 'Введіть email',
      password: 'Введіть пароль',
      country: 'Введіть країну',
      company: 'Введіть компанію',
    },
  },
  statuses: {
    allStatuses: 'Усі публікації',
    published: 'Опубліковані',
    rejected: 'Відхилені',
    draft: 'Чернетки',
    moderation: 'На модерації',
  },
  roles: {
    ROLE_SUPER_ADMIN: 'Супер Адміністратор',
    ROLE_ADMIN: 'Адміністратор',
    ROLE_LDAP_USER: 'Співробітник',
  },
  businessRoles: {
    ROLE_ADMIN: 'Адміністратор',
    super_admin: 'Супер Адміністратор',
    budget_admin: 'Адміністратор бюджетів',
    budget_owner: 'Власник бюджетів',
    administrator_c_b: 'Адміністратор C&B',
    alternate: 'Заступник',
    sub_budget_owner: 'Власник підбюджету',
    hr_director: 'Директор з управління персоналом',
    administrative_manager: 'Адміністративний менеджер',
    signatory: 'Підписант',
    accountant: 'Бухгалтер',
    hr: 'Відділ кадрів',
    employee: 'Співробітник',
    all: 'Усі ролі',
  },
  socialNetworks: {
    facebook: 'Facebook',
    instagram: 'Instagram',
    linkedin: 'LinkedIn',
    twitter: 'Twitter',
    skype: 'Skype',
    telegram: 'Telegram',
    vk: 'ВКонтакті',
    ok: 'Однокласники',
    strava: 'Strava',
  },
  leavePage: {
    question: 'Бажаєте залишити сторінку?',
    info: 'Всі ваші зміни будуть втрачені.',
  },
  userPerformance: {
    infoBlock1: 'Інструкції по процесу',
    infoBlock2: 'Статуси KPI Форми та необхідні дії',
    btnCreate: 'Створити форму KPI',
    faq1: 'Як Заповнити форму KPI? {link}',
    faqText1: '(відео)',
    faq2: 'Погодження форми KPI (для керівників) {link}',
    faqText2: '(відео)',
    faq3: 'Загальна інструкція по процесу {link}',
    faqText3: '(pdf)',
    table: {
      id: 'ID',
      user: 'Співробітник',
      company: 'Назва компанії',
      position: 'Посада',
      positionLevel: 'Рівень посади',
      mustApproveBy: 'Має опрацювати',
      cbAdmin: 'C&B адміністратор',
      year: 'Рік оцінювання',
      disallowEdit: 'Заборонити редагування',
      allowEdit: 'Дозволити редагування',
      status: 'Статус',
    },
    status: {
      draft: 'Чернетка',
      draftDesc: 'форма збережена, але ще не відправлена на погодження',
      not_approved: 'Не погоджена',
      not_approvedDesc: 'керівник повернув форму КРІ на доопрацювання, підлеглому потрібно внести зміни і відправити форму знову на погодження керівника',
      approved_by_user: 'Погоджена співробітником',
      approved_by_userDesc: 'форма відправлена, потребує погодження керівника',
      approved_by_manager: 'Погоджена керівником',
      approved_by_managerDesc: 'керівник вніс зміни в форму, підлеглому потрібно погодити зміни зі своєї сторони',
      approved_by_manager_cb: 'Погоджена адміністратором',
      approved_by_manager_cbDesc: 'С&B Адміністратор погодив форму, процес завершено',
      approved_by_both_side: 'Погоджено обома сторонами',
      approved_by_both_sideDesc: 'форма погоджена керівником і підлеглим, відправлена на С&B Адміністратора',
    },
    form: {
      dataForm: 'Форма введення даних',
      tableForm: 'Форма постановки KPI',
      user: 'ПІБ',
      company: 'Назва компанії',
      department: 'Підрозділ',
      position: 'Посада',
      positionLevel: 'Рівень посади',
      period: 'Період оцінки',
      year: 'Рік оцінки',
      submitBtn: 'Підтвердити',
      declineBtn: 'Відхилити',
      saveDraftBtn: 'Зберегти чернетку',
    },
    selectPeriod: {
      year: 'Рік',
      halfYear: 'Півріччя',
      quarter: 'Квартал',
      month: 'Місяць',
    },
    performance: {
      id: 'п/п',
      description: 'Опис цілі',
      min: 'Мінімально можливе (70-90%)',
      target: 'Цільове виконання (91-100%)',
      over: 'Перевиконання (101-110%)',
      fact: 'Фактичне виконання',
      progress: 'Досягнення',
      kpiLevel: 'Рівень KPIs',
      weight: 'Вага, %',
      totalPercent: 'Загальний % виконання',
      bonusPercent: '% для розрахунку премії',
      addTarget: 'Додати ціль',
      enter: 'Введіть',
      addInfo: 'Додати інформацію',
      requiredError: 'В кожному рядку повинне бути заповнене поле "Опис цілі", "Вага" та "Цільове виконання"',
      weightError: 'Сума ваги має дорівнювати 100%'
    },
    tabs: {
      allForms: 'Форми KPI на погодження',
      myForms: 'Мої форми KPI'
    }
  },
  positionLevel: {
    form: {
      name: 'Назва',
      kpiLevel: 'Рівень KPIs',
      weight: 'Вага, %',
      enter: 'Введіть',
    },
    table: {
      title: 'Назва',
      level: 'Рівень KPIs',
      weight: 'Вага, %',
    },
    select: {
      individual: 'Індивідуальні KPI',
      corporate: 'Корпоративні KPI',
      functional: 'Функціональні KPI',
    }
  },
  performanceGoals: {
    menuTitle: 'КРІ',
    table: {
      uuid: 'ID',
      name: 'Назва',
      company: 'Назва компанії',
      department: 'Підрозділ',
      position: 'Посада',
      positionLevel: 'Рівень посади',
    },
    form: {
      company: 'Назва компанії',
      department: 'Підрозділ',
      position: 'Посада',
      positionLevel: 'Рівень посади',
      name: 'Назва',
      min: 'Мінімально можливе (70-90%)',
      target: 'Цільове виконання (91-100%)',
      over: 'Перевиконання (101-110%)',
      fact: 'Фактичне виконання',
      progress: 'Досягнення, %',
      kpiLevel: 'Рівень KPIs',
      weight: 'Вага, %',
      totalPercent: 'Загальний % виконання',
      bonusPercent: '% для розрахування премії',
      enter: 'Введіть',
      autoCalc: 'Обчислюється автоматично',
      achievement: '% досягнення від',
    }
  },
  page: {
    login: 'Авторизація',
    indexNews: 'Новини',
    viewNews: 'Новина',
    createNews: 'Створення новини',
    createBusinessTrip: 'Створення відрядження',
    editNews: 'Редагування новини',
    indexNewsAdmin: 'Новини',
    indexTopicAdmin: 'Категорії новин',
    viewTopicAdmin: 'Категорія',
    createTopicAdmin: 'Створення категорії',
    editTopicAdmin: 'Редагування категорії',
    viewProfile: 'Профіль',
    indexLogsAdmin: 'Логування',
    indexBannerAdmin: 'Банер',
    createBannerAdmin: 'Створення банера',
    editBannerAdmin: 'Редагування банера',
    indexQuizAdmin: 'Опитування',
    indexUsersAdmin: 'Користувачі',
    createUserAdmin: 'Створення користувача',
    editUserAdmin: 'Редагування користувача',
    indexSettingsAdmin: 'Налаштування',
    knowledgeBase: 'Документи',
    knowledgeBasePage: 'Політики та Шаблони',
    indexPagesAdmin: 'Сторінки',
    createPageAdmin: 'Створення сторінки',
    editPageAdmin: 'Редагування сторінки',
    indexRegionAdmin: 'Регіони',
    indexDictionariesAdmin: 'Словники',
    indexCorporateResourcesAdmin: 'Корпоративні ресурси',
    createCorporateResourcesAdmin: 'Створення корпоративного ресурсу',
    editCorporateResourcesAdmin: 'Редагування корпоративного ресурсу',
    indexCorrespondencesAdmin: 'Реєстрація документів',
    createCorrespondencesAdmin: 'Створення кореспонденції типу',
    editCorrespondencesAdmin: 'Редагування кореспонденції',
    indexPerformanceGoals: 'Цілі',
    createPerformanceGoals: 'Створення цілі',
    editPerformanceGoals: 'Редагування цілі',
    indexPositionLevel: 'Рівень посади',
    createPositionLevel: 'Створення рівня посади',
    editPositionLevel: 'Редагування рівня посади',
    indexUserPerformance: 'Performance Management',
    createUserPerformance: 'KPI',
    editUserPerformance: 'KPI',
    indexVacations: 'Відпустка',
    createVacations: 'Створення відпустки',
    editVacations: 'Редагування відпустки',
    indexPageCategoriesAdmin: 'Категорії сторінок',
    createPageCategoriesAdmin: 'Створення категорії',
    editPageCategoriesAdmin: 'Редагування категорії',
    indexDocumentTypesAdmin: 'Тип документу',
    createDocumentTypesAdmin: 'Створення типу документу',
    editDocumentTypesAdmin: 'Редагування типу документу',
    indexDocumentCategoriesAdmin: 'Департамент',
    createDocumentCategoriesAdmin: 'Створення департаменту',
    editDocumentCategoriesAdmin: 'Редагування департаменту',
    indexShippingMethodsAdmin: 'Спосіб відправлення',
    createShippingMethodsAdmin: 'Створення способу відправлення',
    editShippingMethodsAdmin: 'Редагування способу відправлення',
    indexSubmittingBudgets: 'Внесення бюджетів',
    indexDriversAdmin: 'Водії',
    createDriversAdmin: 'Створення картки водія',
    editDriversAdmin: 'Редагування картки водія',
    driversSchedule: 'Бронювання водіїв',
    indexHallsAdmin: 'Зали',
    createHallsAdmin: 'Створення залу',
    editHallsAdmin: 'Редагування залу',
    hallsReservation: 'Бронювання залу',
    greetingAdmin: 'Вітання',
    events: 'Події',
    correspondence: 'Кореспонденція',
    correspondenceCategory: 'Кореспонденція {category}',
    createEvent: 'Створення події',
    editEvent: 'Редагування події',
    editBusinessTrip: 'Редагування заявки',
    indexSearch: 'Пошук',
    'about-company': 'Про компанію',
    'about-products': 'Про продукцію',
    'company-structure': 'Структура компанії',
    collaboration: 'Сумісна праця',
    welcome: 'Ласкаво просимо!',
    404: '404',
    policy: 'Умови використання порталу',
    viewBusinessTrips: 'Відрядження',
  },
  subscribtions: {
    noUsers: 'На даний момент ви не підписані на своїх колег.',
  },
  error: {
    404: {
      title: 'Такої сторінки не знайдено :(',
      desc: 'Можливо вона була видалена або змінила адресу',
      btn: 'перейти на головну',
    },
    kpi: {
      title: 'Форма KPI була видалена :(',
      desc: 'Якщо це помилка, будь ласка, зверніться до адміністратора',
    }
  },
  modal: {
    areYouSureToDelete: 'Ви впевнені, що хочете видалити?',
    areYouSureToCancelTrip: 'Ви впевнені, що хочете скасувати?',
    areYouSureToCancel: 'Ви впевнені, що хочете анулювати?',
    areYouSureToCancelEntry: 'Ви впевнені, що хочете анулювати<br>запис?',
    deletingTextModal: 'Видалення регіону',
    areLongTime: 'Процес може зайняти тривалий час...',
  },
  indexNews: {
    new: 'Новина',
    likedNew: 'Не сподобалося | Сподобалося {n} людині | Сподобалося {n} людям | Сподобалося {n} людям',
  },
  greeting: {
    show: 'Не показувати привітання ',
    create: 'Створення привітання',
    edit: 'Редагування привітання',
    preview: 'Передпроглядання привітання',
    form: {
      image: {
        label: 'Завантажте обкладинку привітання',
      },
      text: {
        label: 'Текст привітання ',
        placeholder: 'Введіть привітання ',
      },
    },
  },
  createNews: {
    titleNew: 'Створення новини',
    titleEdit: 'Редагування новини',
    preview: 'Перегляд новини',
    form: {
      title: 'Назва',
      subTitle: 'Підзаголовок',
      topic: 'Категорія новини',
      image: 'Зображення',
      position: 'Порядковий номер',
      body: 'Зміст',
      commentable: 'Дозволити коментувати новини',
      refuseReason: 'Причина',
      slug: 'Слаг',
      url: 'Посилання на ресурс',
    },
    placeholder: {
      title: 'Введіть назву',
      subTitle: 'Введіть підзаголовок',
      titleEn: 'Назва локальною мовою',
      text: 'Введіть основний текст',
      topic: 'Оберіть категорію',
      refuseReason: 'Введіть причину',
      slug: 'Введіть слаг',
      url: 'Введіть посилання на ресурс'
    },
    uploadImageTitle: 'Завантажте обкладинку новини',
    uploadImageDesc: 'Допустимі формати: JPEG, PNG. Максимальний розмір: 8 МБ.<br/> Мінімальна роздільна здатність: {size}.',
    refuseReason: 'Причина відхилення',
  },
  viewNews: {
    isModerate: 'Новина проходить модерацію',
    shareNews: 'Поділитися новиною із колегами',
    newsSent: 'Новину відправлено',
    statuses: {
      rejected: 'Новина не пройшла модерацію',
      rejectedDesc: 'Ваша новина не пройшла модерації. Зверніться до адміністратора.',
      rejectedSuccess: 'Новина успішно відхилена',
      draft: 'Новина у чернетках',
      draftDesc: 'Вашу новину не опубліковано.',
      moderation: 'Новина на модерації',
      moderationDesc: 'Вашу новину додано в чергу на модерацію. Вона з\'явиться на порталі у випадку, якщо один з модераторів її схвалить.',
      published: 'Новина опублікована',
      publishedDesc: 'Ваша новина пройшла модерацію та опублікована на порталі.',
      waitModeration: 'Після модерації новину буде опубліковано на порталі.',
      savedToDrafts: 'Новина збережена в чернетки',
      offModeration: 'Вимкнути режим модерації?',
      offModerationDesc: 'Всі новини, що очікують на модерацію, будуть автоматично опубліковані.',
    },
  },
  indexNewsAdmin: {
    name: 'Назва',
    author: 'Автор',
    status: 'Статус',
  },
  indexTopicAdmin: {
    new: 'Категорію',
    name: 'Назва',
    shared: 'Доступна для публікації',
  },
  indexRegionAdmin: {
    new: 'Регіон',
    name: 'Назва',
    regionExists: 'Така назва регіону вже існує',
  },
  indexDictionariesAdmin: {
    tripPurposes: 'Мета поїздки',
    currencies: 'Валюти',
    transportTypes: 'Типи транспорту',
    ticketClasses: 'Клас квитка',
    services: 'Сервіси',
    currencyCode: 'Код валюти',
    availableForPublish: 'Доступна для публікації',
    availableForSelection: 'Доступно для вибору',
  },
  indexSubmittingBudgets: {
    description: 'Внесіть бюджети/підбюджети, курс валют та добові',
    budgets: 'Бюджети',
    reports: 'Звіти',
    currencyRates: 'Курс валют',
    accommodationLimits: 'Ліміти на проживання',
    dailyAllowance: 'Добові',
  },
  indexUsersAdmin: {
    name: 'Ім\'я',
    role: 'Роль',
    roles: 'Ролі',
    department: 'Департамент',
    alternates: 'Заступники',
    alternate: 'Заступник',
    subBudgets: 'Власники підбюджету',
    subBudget: 'Власник підбюджету',
    companies: 'Компанії',
    previewText: 'Надайте активні ролі ключовим користувачам',
    roleAlreadyExist: 'Роль вже присвоєно {value}',
    budgetOwnersAlternate: 'Заступник у власника бюджету',
    budgetOwnersSubBudgetOwner: 'Власник підбюджету у власника бюджету',
  },
  vacations: {
    table: {
      id: 'Номер',
      createdAt: 'Дата створення',
      status: 'Статус',
      user: 'Співробітник',
      manager: 'Керівник',
      startDate: 'Дата старту',
      endDate: 'Дата завершення',
    },
    form: {
      user: 'Співробітник',
      manager: 'Керівник',
      startDate: 'Дата старту',
      endDate: 'Дата завершення',
      comment: 'Коментар',
      enter: 'Введіть',
      enterComment: 'Введіть коментар',
      submitBtn: 'Створити',
      saveBtn: 'Зберегти',
      daysAmount: 'К-ть днів',
    },
    statuses: {
      approved: 'Затверджено',
      closed: 'Закрито',
      processing: 'В обробці',
      done: 'Оформлено',
      rejected: 'Відхилено',
    },
    modal: {
      createdAt: 'Дата створення',
      userName: 'ПІБ Співробітника',
      managerName: 'ПІБ Керівника',
      datesOfVacation: 'Дата відпустки',
      daysAmount: 'Кількість днів',
      additional: 'Додатково',
      submitBtn: 'Затвердити',
      submitHrBtn: 'Оформити',
      declineBtn: 'Відхилити',
      declineHrBtn: 'Відміна',
    },
    days: {
      vacation: 'Відпустка',
      balance: 'Баланс',
      usedDays: 'Витрачених днів',
      leftDays: 'Залишок днів',
      requiredDays: 'Обов’язкові дні відпустки',
      leftDayEndYear: 'Залишок днів на кінець року',
      noData: 'На жаль сталася помилка або дані відсутні. Зверніться до Вашого HR-менеджера.',
    },
    calendar: {
      usedDaysTitle: 'Використано днів відпустки у поточному році',
      plannedTitle: 'Запланований графік відпустки',
    },
  },
  indexDriversAdmin: {
    photo: 'Аватар',
    name: 'ПІБ',
    car: 'Авто',
    carPhoto: 'Фото авто',
    carNumber: 'Номерний знак',
    phone: 'Контакти водія',
    form: {
      photo: 'Завантажте фото водія',
      name: 'ПІБ водія',
      car: 'Авто',
      carNumber: 'Номерний знак',
      carPhoto: 'Завантажте фото авто',
      type: 'Тип перевезення',
      phone: 'Телефон 1',
      secondPhone: 'Телефон 2',
      smsPhone: 'Контакт для відправки SMS',
      enter: 'Введіть',
      maxSize: 'Максимальний розмір: {amount}МБ'
    },
    modal: {
      driverBooking: 'Бронювання водія',
      user: 'Користувач',
      startDate: 'Дата старту',
      endDate: 'Дата закінчення',
      time: 'Час',
      route: 'Маршрут',
      phone: 'Номер телефону',
      type: 'Тип',
      comment: 'Комментар',
      staff: 'Персонал',
      documents: 'Документи',
      cargo: 'Вантажі/Вода',
      submitBtn: 'Забронювати',
      deleteBtn: 'Видалити',
    }
  },
  indexHallsAdmin: {
    table: {
      image: 'Фото',
      name: 'Назва',
      type: 'Тип',
      numberOfSeats: 'К-сть місць',
      hasProjector: 'Наявність проєктора',
    },
    form: {
      image: 'Завантажте фото залу',
      name: 'Назва',
      type: 'Тип',
      numberOfSeats: 'Кількість місць',
      hasProjector: 'Наявність проєктора',
      enter: 'Введіть',
    },
    modal: {
      hallReservation: 'Бронювання залу',
      name: 'Назва',
      user: 'Користувач',
      comment: 'Коментар',
      commentPlaceholder: 'Введіть коментар',
      submitBtn: 'Застосувати',
      deleteBtn: 'Видалити',
    },
    select: {
      conference_hall: 'Конференцзал',
      massage: 'Массаж',
      meeting_room: 'Meeting room',
    }
  },
  indexLogsAdmin: {
    date: 'Дата час',
    entity: 'Сутність',
    name: 'Назва',
    action: 'Дія',
    author: 'Автор',
    businessTripName: 'Назва/№ заявки',
  },
  indexSettingsAdmin: {
    name: 'Ім\'я',
    status: 'Статус',
  },
  indexBannerAdmin: {
    name: 'Назва',
    status: 'Статус',
    statuses: {
      active: 'Активний',
      notActive: 'Неактивний',
    },
    new: 'Банер',
  },
  indexQuizAdmin: {
    new: 'Опитування',
    dateAndTime: 'Дата, время',
    question: 'Питання',
    status: 'Статус',
  },
  createQuizAdmin: {
    creating: 'Створення опитування',
    editing: 'Редагування опитування',
    form: {
      question: 'Питання',
      answer: 'Варіант відповіді {number}',
      anonymous: 'Анонімне опитування',
    },
    placeholder: {
      question: 'Задайте питання',
      answer: 'Введіть відповідь',
    },
  },
  createBannerAdmin: {
    preview: 'Перегляд банера',
    titleNew: 'Створення банера',
    titleEdit: 'Редагування банера',
    titleCrop: 'Завантаження обкладинки',
    uploadImageTitle: 'Завантажте обкладинку банеру або банер',
    uploadImageDesc: 'Допустимі формати: JPEG, PNG. Максимальний розмір: 8 МБ. Мінімальна роздільна здатність: 800х100.',
    form: {
      textBanner: 'Текст банера',
      textColor: 'Колір тексту',
      textColorBanner: 'Колір тексту банера',
      textBtnColor: 'Колір тексту кнопки',
      btnColor: 'Колір кнопки',
      textBtn: 'Текст кнопки',
      link: 'Посилання для кнопки',
      startDate: 'Старт публікації',
      timeStart: 'Время',
      endDate: 'Закінчення публікації',
      timeEnd: 'Час',
    },
    placeholder: {
      textBanner: 'Введіть основний текст банера',
      textBtn: 'Введіть текст кнопки',
      link: 'Вставте посилання',
      startDate: 'Дата',
      timeStart: 'Час',
      endDate: 'Дата',
      timeEnd: 'Час',
    },
    danger: {
      startDate: 'Дата публікації',
      endDate: 'Дата закінчення публікації',
    },
    activeMessage: 'Активним може бути лише один банер',
  },
  createTopicAdmin: {
    creating: 'Створення категорії',
    editing: 'Редагування категорії',
    form: {
      name: 'Назва категорії',
      shared: 'Доступна для публікації',
    },
    placeholder: {
      name: 'Введіть назву категорії',
    },
  },
  createRegionAdmin: {
    creating: 'Створення регіону',
    editing: 'Редагування регіону',
    form: {
      name: 'Назва регіону',
      rawCountries: 'Назви країн',
    },
    placeholder: {
      name: 'Введіть назву регіону',
    },
  },
  editPageAdmin: {
    title: 'Редагування сторінки',
    infoIcon: 'Завантажте значок для сторінки',
    showInMenu: 'Показувати у меню',
    resourceIcon: 'Завантажте значок для ресурсу',
    subtitle: 'Підзаголовок локальною мовою',
    subtitleEn: 'Підзаголовок англійською мовою',
    localTitle: 'Назва локальною мовою',
    englishTitle: 'Назва англійською мовою',
  },
  createDictionariesAdmin: {
    title: {
      trip_purpose: 'Створення мети поїздки',
      currencies: 'Створення валюти',
      transport: 'Створення типу транспорту',
      ticket: 'Створення класу квитка',
      service: 'Створення сервісу',
    },
    label: {
      trip_purpose: 'Мета поїздки',
      currencies: 'Валюта',
      transport: 'Тип транспорту',
      ticket: 'Клас квитка',
      service: 'Сервіс',
    },
    placeholder: 'Введіть назву',
    child: {
      transport: 'Клас квитка',
    },
  },
  editDictionariesAdmin: {
    title: {
      trip_purpose: 'Редагування мети поїздки',
      currencies: 'Редагування валюти',
      transport: 'Редагування типу транспорту',
      ticket: 'Редагування класу квитка',
      service: 'Редагування сервісу',
    },
  },
  createBudgetAdmin: {
    title: 'Створення бюджету',
    subBudgetTitle: 'Створення підбюджету',
    budget: 'Бюджет',
    subBudget: 'Підбюджет',
    budgetOwner: 'Власник бюджету',
    subBudgetOwner: 'Власник підбюджету',
    budgetSubbudgetName: 'Назва бюджету/підбюджету',
    budgetName: 'Назва бюджету',
    subBudgetName: 'Назва підбюджету',
    defaultBudget: 'Бюджет за замовчуванням',
    defaultSubBudget: 'Підбюджет за замовчуванням',
    placeholder: {
      user: 'Оберіть власника бюджету',
      subBudgetOwner: 'Оберіть власника підбюджету',
      name: 'Введіть назву бюджету',
      subName: 'Введіть назву підбюджету',
      year: 'Виберіть рік',
    },
    createBudget: 'Створити бюджет',
    createSubBudget: 'Створити підбюджет',
    empty: 'Бюджет ще не створено',
    emptyByParams: 'За заданими параметрами нічого не знайдено',
  },
  editBudgetAdmin: {
    title: 'Редагування бюджету',
    subBudgetTitle: 'Редагування підбюджету',
  },
  createCurrencyRate: {
    currencyRate: 'Курс валют',
    addRate: 'Додати курс',
    placeholders: {
      date: 'Виберіть дату',
    },
    empty: 'Курс валют ще не створено',
  },
  editDailyAllowance: {
    dailyAllowance: 'Добові',
    dailyAllowanceSize: 'Розмір добових',
    travelDirection: 'Напрямок поїздки',
    travelDirectionPlaceholder: 'Введіть напрямок подорожі',
    create: 'Створити добові',
    creating: 'Створення добових',
    editing: 'Редагування добових',
  },
  createAccLimit: {
    create: 'Додати ліміт на проживання',
    dailyAllowance: 'Напрямок поїздки',
    placeholder: {
      dailyAllowance: 'Оберіть напрямок поїздки',
    },
    editing: 'Редагування ліміту на проживання',
    creating: 'Створення ліміту на проживання',
    amount: 'Ліміт на проживання',
    year: 'Рік',
  },
  budgetReport: {
    total: 'Усього',
    used: 'Використані',
    remaining: 'Залишок',
    owners: 'Власник(и) бюджету/підбюджету',
    budget: 'Бюджет',
    sub_budget: 'Підбюджет',
    noBudgets: 'Бюджет ще не створено',
    allDepartments: 'Усі департаменти',
    corporate: 'Корпоративний',
    finance: 'Фінанси',
    spent: 'Витрачено',
    balance: 'Залишок',
    amountPending: 'Сума на розгляді',
  },
  businessTrips: {
    faq: 'Посібник для функціоналу {link}',
    faqText: '«Відрядження»',
    comments: 'Коментарі',
    transfer: 'Трансфер',
    route: 'Маршрут',
    created: 'Створено',
    title: 'Відрядження',
    allTrips: 'Усі заявки',
    daysCount: 'Кількість днів',
    myTrips: 'Мої заявки',
    trip: 'Заявка',
    trips: 'Заявки',
    approved: 'Затверджені',
    inProcessing: 'В обробці',
    completed: 'Завершені',
    budgets: 'Бюджети',
    reportsByEmployee: 'Звіт по співробітникам',
    number: 'Номер',
    status: 'Статус',
    employeeOrNot: 'Співробітник/ Консультант',
    responsible: 'Виконавець',
    takeOnWork: 'Взяти в роботу',
    tripPurpose: 'Мета поїздки',
    destination: 'Пункт призначення',
    startDateToEndDate: 'Дата старту/ закінчення',
    plan: 'План',
    fact: 'Факт',
    planSum: 'Сума ({currencySymbol}) план',
    factSum: 'Сума ({currencySymbol}) факт',
    filters: {
      startDate: 'Дата старту',
      endDate: 'Дата закінчення',
      createdDate: 'Дата створення',
      noResponsible: 'Без виконавця',
    },
    deleteReason: 'Причина видалення',
    cancelReason: 'Причина скасування',
    cancelSum: 'Сума скасування',
    submitCancel: 'Підтвердити скасування',
    submitCancelBtn: 'Відмінити',
    roleStatuses: {
      approved: 'Заявку затверджено',
      pending: 'Заявка на затвердженні',
      rejected: 'Заявка відхилена',
    },
    factSpent: 'Фактичні витрати',
    pinnedEmployees: 'Закріплені працівники',
    viewFrom: 'Ви переглядаєте сторінку від ',
    fromAllBudgetOwners: 'Всіх власників бюджету',
    inputAccountantExpensesReason: 'Введіть причину перевищення фактичних витрат',
    noteModal: {
      title: 'Правила оформлення відрядження',
      more: 'Більше про відрядження',
      isAcquainted: 'Ознайомлений',
      fields: {
        rule: 'Правило',
        shortDescription: 'Короткий опис',
        sources: 'Ресурси',
      },
      items: {
        bookingAgent: {
          rule: 'Через кого бронюємо?',
          shortDescription: 'Через <span class="font-weight-boldest">Агенцію</span>, не Booking/OLX/Instagram/Airbnb !!!'
        },
        applicationDeadline: {
          rule: 'Термін заявки',
          shortDescription: '<div><span class="font-weight-boldest">Україна</span> — ≥5 днів</div><div><span class="font-weight-boldest">Закордон</span> — ≥ 7 днів</div><div>*подача заявки в коротші терміни не гарантує наявність квитків/готелів</div><div class="font-weight-boldest">*подача заявки на відрядження день в день суворо заборонена!</div>'
        },
        approval: {
          rule: 'Погодження',
          shortDescription: '<ul><li>Після подачі заявки, офіс-менеджери заповнюють орієнтовні суми і відправляють заявку на затвердження Власнику бюджету (<span class="font-weight-boldest">увага:</span> не завжди власник бюджету є безпосереднім керівником)</li><li>Всі закордонні відрядження мають бути погоджені гендиректор (через ел. пошта) перед створенням заявки на порталі</li></ul>'
        },
        accommodationLimits: {
          rule: 'Ліміти проживання',
          shortDescription: '<div class="font-weight-boldest">Україна:</div><ul><li>великі міста — <span class="font-weight-boldest">до 2 200 грн/доба;</span></li><li>малі міста — <span class="font-weight-boldest">до 1 800 грн/доба.</span></li></ul><div>*в системі встановлені ліміти за середнім значенням - 2000 грн/доба</div><div class="font-weight-boldest">Закордон:</div><ul><li>Швейцарія, США, Великобританія - 300 €</li><li>Інші - 200 €</li></ul>'
        },
        overLimit: {
          rule: 'Переліміт',
          shortDescription: 'Відповідальність за перевищення ліміту покладається на Власника бюджету'
        },
        dailyAllowance: {
          rule: 'Добові',
          shortDescription: '<ul><li><span class="font-weight-boldest">Україна</span> — 500 грн</li><li><span class="font-weight-boldest">Закордон</span> — 50 €</li></ul>'
        },
        notReimbursed: {
          rule: 'Не відшкодовуються',
          shortDescription: 'Міні-бар, алкоголь, тютюн, чайові та інші'
        },
        duration: {
          rule: 'Тривалість',
          shortDescription: '<ul><li><span class="font-weight-boldest">Україна</span> — до 30 днів</li><li><span class="font-weight-boldest">Закордон</span> — до 60 днів</li></ul>'
        },
        transport: {
          rule: 'Транспорт',
          shortDescription: '<span class="font-weight-boldest">Водії</span> бронюються самостійно через Outlook <span class="font-weight-boldest">Корпоративне таксі</span> за запитом на пошту: <a href="mailto:office12@morshynska.ua">office12@morshynska.ua</a>',
          sources: '<a href="https://myids.morshynska.ua/login?path=%2Fpages%2Fbookingdrivers" target="_blank">Посилання</a>'
        },
        expenseCompensation: {
          rule: 'Компенсація витрат',
          shortDescription: 'Самостійні витрати компенсуються лише за умови подання підтверджуючих документів до бухгалтерії (чеки, акти, квитанції, накладні)'
        },
        importantDocuments: {
          rule: 'Важливі документи на відрядження',
          shortDescription: 'Посвідчення на відрядження та Витяг з Наказу оформлюється офіс-менеджером і прикріплюється до заявки.'
        },
        otherDocuments: {
          rule: 'Інші документи',
          shortDescription: 'Всі інші документи: квитки, ваучер на готель тощо офіс-менеджери прикріплюють до заявки на порталі'
        },
        otherImportantDocuments: {
          rule: 'Інші важливі документи',
          shortDescription: '<ul class="business-note-table_list-number"><li>обов\'язково вказуйте всю необхідну інформацію для організації відрядження (паркінг, бажана локація тощо)</li><li>для закордонних відряджень враховуйте необхідність мати при собі додаткові документи для військовозабов\'язаних:</li></ul><ul><li>наказ про відрядження з підписом керівника підприємства та печаткою (за наявності);</li><li>посвідчення про відрядження;</li><li>довідку про бронювання військовозобов\'язаного працівника за підприємством (за підписом відповідальної особи / HR);</li><li>паспорт громадянина України для виїзду за кордон;</li><li>військово-обліковий документ (військовий квиток або тимчасове посвідчення військовозобов\'язаного);</li><li>застосунок «Резерв+» з актуальними даними;</li><li>запрошення від приймаючої сторони, квиток на конференцію або інші документи, що підтверджують мету виїзду за кордон;</li><li>поліс туристичного страхування на період відрядження;</li><li>інші документи, що підтверджують підстави для виїзду за кордон відповідно до вимог чинного законодавства України (за необхідності).</li></ul><div class="font-weight-boldest">За отримання документів у відповідних відділів компанії та наявність їх під час перетину кордону відповідальний працівник!</div><ol start="3" style="padding-inline-start: 20px"><li>для закордонних відряджень перевіряйте актуальні правила перетину кордону тої чи іншої країни (наявність страхового полісу, ваучеру на готель, готівки (та обмеження на перевезення валюти без декларування - 10 000 $), обмеження на перевезення тютюнових виробів (не більше 2 уп) та алкоголю, заборона перевезення м\'ясних, молочних продуктів, фруктів тощо (навіть бутерброди/йогурт в дорогу як власний перекус)</li></ol>'
        },
        reporting: {
          rule: 'Звітування про відрядження',
          shortDescription: '- Заповнене посвідчення на відрядження з відмітками про вибуття та прибуття працівник має передати до бухгалтерії протягом 7 робочих днів після завершення + додати інші документи, якщо вони необхідні (чеки про дод.витрати тощо)<div class="font-weight-boldest">За наявність та здачу документів відповідальний працівник!</div>'
        }
      }
    }
  },
  createBusinessTrip: {
    title: 'Створення відрядження',
    createTrip: 'Створити відрядження',
    employee: 'Співробітник',
    notEmployee: 'Консультант',
    fio: 'ПІБ',
    enter: 'Введіть',
    choose: 'Оберіть',
    startBusinessTrip: 'Початок відрядження',
    endBusinessTrip: 'Кінець відрядження',
    periodBusinessTrip: 'Період відрядження',
    dayCounts: 'Кількість днів: {count}',
    additional: 'Додатково',
    transferAirport: 'Трансфер до/з аеропорту',
    transferOffice: 'Трансфер до/з офісу або іншого пункту',
    datePlaceTime: 'Дата, місце та час',
    transportType: 'Тип транспорту',
    transport: 'Проїзд',
    chooseDate: 'Оберіть дату',
    cityAndCountry: 'Пункт призначення',
    departurePoint: 'Пункт відправлення',
    nameOfCompany: 'Назва підприємства, на яке здійснюється відрядження',
    nameOfCompanyModal: 'Підприємство, на яке здійснюється відрядження',
    residence: 'Проживання',
    residencePeriod: 'Період проживання',
    country: 'Країна',
    city: 'Місто',
    placeholder: {
      fio: 'Введіть ПІБ',
      nameOfCompany: 'Введіть назву підприємства',
      user: 'Оберіть співробітника',
      transportType: 'Оберіть тип транспорту',
      ticketType: 'Оберіть клас квитка',
      additional: 'Оберіть додаткові послуги',
      transferAirport: 'Вкажіть дату, місце та час',
      otherInfo: 'Побажання щодо поїздки',
      choose: 'Оберіть',
    },
    errors: {
      cantCreateTrip: 'Неможливо створити відрядження',
      notFoundRoleAndBudgetCount: 'Для Вашого юніту бізнес не був призначений {roles} і не був виділений бюджет. Будь ласка, зверніться до Вашого керівника.',
      not_found_role: 'Для Вашого юніту бізнес не був призначений {roles}. Будь ласка, зверніться до Вашого керівника.',
      budget_count: 'Для Вашого бізнес-юніту не було виділено бюджет. Будь ласка, зверніться до Вашого керівника.',
    },
    empty: 'У Вас ще не було відряджень',
    emptyDesc: 'Створіть заявку на відрядження',
    arrange: 'Оформити',
    successGoToApprove: 'Заявка {number} надіслана на обробку.',
    successGoToApproveNoNumber: 'Заявка надіслана на обробку.',
    successGoToReApprove: 'Заявка {number} надіслана на повторне затвердження.',
    successClosed: 'Заявка {number} закрита.'
  },
  editBusinessTrip: {
    title: 'Редагування відрядження',
    request: 'Заявка {number}',
    budgetOwnerForApprove: 'Власник бюджету/підбюджету',
    budget: 'Назва бюджету/підбюджету',
    hotelPrice: 'Вартість проживання',
    transportPrice: 'Вартість транспорту',
    transferPrice: 'Вартість трансферу',
    dailyPayment: 'Добові',
    otherExpenses: 'Інше',
    otherExpensesDestination: 'Призначення суми "Інше"',
    modalCancelSuccess: 'Запит відправлено',
    modalCancelSuccessText: 'Запит відправлено адмін. менеджеру. Очікуйте повідомлення на електронну адресу про скасування.',
    total: 'Усього',
    placeholder: {
      budgetOwnerForApprove: 'Виберіть зі списку',
      budget: 'Виберіть зі списку',
    },
    reApproval: 'Повторне затвердження',
    reApprovalDesc: 'Надіслати заявку на повторне затвердження?',
    wishes: 'Побажання',
    accommodation: 'Проживання',
    transport: 'Транспорт',
    transfer: 'Трансфер',
    budgetBalance: 'Залишок бюджету',
    uploadDocumentsTickets: 'Завантажте документи, квитки',
    hotelPriceLimitExceeds: 'Перевищує ліміт на {difference} {currency}',
    hotelPriceLimitWithin: 'Входить в ліміт проживання {limit} {currency} ({difference} {currency} в межах норми)'
  },
  businessTripStatuses: {
    created: 'В обробці',
    wait_approval: 'Чекає на затвердження',
    approved: 'Затверджено',
    partially_approved: 'Частково затверджено',
    completed: 'Оформлено',
    closed: 'Закрито',
    processing: 'Взято в роботу',
    decline: 'Відхилено',
    cancel_request: 'Запит на скасування',
    canceled: 'Скасовано',
  },
  profile: {
    information: 'Інформація',
    articlesMy: 'Мої публікації',
    articles: 'Публікації',
    birthday: 'День народження',
    birthdaysModal: 'Дні народження',
    country: 'Країна',
    city: 'Місто',
    businessUnit: 'Бізнес-юніт',
    company: 'Компанія',
    socialProfiles: 'Соціальні профілі',
    contactInfo: 'Контактна інформація',
    phone: 'Телефон',
    mail: 'Email',
    workAddress: 'Адреса роботи',
    career: 'Кар\'єра',
    joinedToTeam: 'Приєднався(-лась) до команди IDS UKRAINE',
    leader: 'Керівник',
    personalInfo: 'Особиста інформація',
    language: 'Володіння мовами',
    certificationsAndSkills: 'Сертифікації та додаткові навички',
    workExperience: 'Досвід роботи до IDS UKRAINE',
    hobbies: 'Захоплення',
    functional: 'Функціонал',
    removedText: 'На даний момент цей співробітник не працює в компанії',
  },
  profileSettings: {
    title: 'Налаштування профілю',
    mainInformation: 'Основна інформація',
    socialProfiles: 'Соціальні профілі',
    alerts: 'Оповіщення',
    upload: 'Завантажити фото',
    receiveAlerts: 'Отримання повідомлень на поштову скриньку',
    form: {
      avatar: 'Фото',
      workAddress: 'Адреса роботи',
      languages: 'Володіння мовами',
      additionalSkills: 'Сертифікації та додаткові навички',
      prevExperience: 'Досвід роботи до IDS UKRAINE',
      hobbies: 'Захоплення',
      social: 'Соц. мережі',
      link: 'Посилання',
      functional: 'Функціонал',
      locale: 'Мова порталу',
      receivePublicationMessage: 'Відповіді на мої публікації',
      receiveBirthdayMessage: 'Вітання з днем народження',
    },
    placeholder: {
      workAddress: 'Введіть адресу',
      languages: 'Мови',
      additionalSkills: 'Напишіть про свої сертифікації та навички',
      prevExperience: 'Досвід роботи',
      hobbies: 'Напишіть про свої захоплення',
      social: 'Виберіть соц. мережі',
      link: 'Вставте посилання',
      functional: 'Опишіть, які обов\'язки ви виконуєте',
    },
  },
  staffSearch: {
    name: 'Ім\'я',
    phone: 'Телефон',
    email: 'Пошта',
  },
  search: {
    title: 'Результати пошуку',
    desc: 'На запит <span class="font-weight-bold">{search}</span> знайдено <span class="font-weight-bold">{count}</span> результатів',
    articles: 'Новини',
    staff: 'Співробітники',
    medias: 'Документи',
    events: 'Події',
    empty: {
      title: 'Пошук не дав результатів',
      desc: 'Спробуйте використати інші ключові слова',
    },
  },
  auth: {
    auth: 'Авторизація',
    authDesc: 'Для входу використовуйте Ваші корпоративні облікові дані',
    authConfirm: 'Перевірте свою пошту',
    authConfirmDesc: 'Ми щойно надіслали шестизначний код на адресу <span class="font-weight-boldest">{email}</span>. Не закривайте це вікно, поки перевіряєте свою поштову скриньку, а потім введіть наведений нижче код.',
    form: {
      email: 'Email',
      password: 'Пароль',
      code: 'Код',
    },
    iAccept: 'Я приймаю',
    termsOfUseOfThePortal: 'правила користування порталом',
    signIn: 'Увійти',
    or: 'чи',
    orExternal: 'або (тільки для зовнішніх користувачів)',
    signInMicrosoft: 'Увійти за допомогою Microsoft',
    didtReceiveLetter: 'Не надійшов лист?',
    sendCodeAgain: 'Надіслати код ще раз',
    codeSent: 'Ваш код надіслано повторно.',
    error: {
      invalidCredentials: 'Логін або пароль введено неправильно',
      blockAccount: 'Ваш обліковий запис заблоковано. Щоб відновити доступ, зверніться до адміністратора',
      accountUnlock: 'Користувача розблоковано',
      invalidCode: 'Ви ввели неправильний код. Спробуйте ще раз.',
    },
  },
  validation: {
    invalid: '{name} не є допустимим',
    required: '{name} обов\'язкове поле',
    requiredIf: '{name} обов\'язкове поле',
    greaterThan: 'Має бути більше {value}',
    decimal: 'Тільки число',
    lessThan: 'Максимум {value}',
    requiredDays: 'Виберіть дні для налаштування повторення',
    alphaNum: '{name} повинен бути англійською мовою і без пробілів',
    alphaNumCustom: '{name} повинен бути англійською мовою і без пробілів',
    variant: 'Обов\'язкове поле',
    url: '{name} має бути url адресою',
    imageFormat: 'Неправильний формат файлу. Допустимий формат: {format}',
    imageWeight: 'Файл дуже великий. Максимальний розмір: {weight} MB',
    imageSize: 'Неправильна роздільна здатність файлу. Мінімальний розмір: {size}',
    imageMaxCount: 'Максимальна кількість завантажуваних файлів - {count}',
    fileNameMaxCount: 'Максимальна кількість символів у назві файлу - {count}',
    fileMinWeight: 'Мінімальний розмір файлу: {size} KB',
    someFileAlreadyExists: 'Один із файлів вже існує в системі',
    isAfter: '{name} має бути після дати старту',
    minLength: 'Мінімальна кількість символів - {count}',
    maxLength: 'Максимальна кількість символів - {count}',
    maxValue: 'Максимальне значення - {count}',
    minValue: 'Мінімальне значення - {count}',
    fileType: 'Формат файлу, що завантажується, не підтримується системою',
    containsUppercase: 'Пароль повинен містити велику літеру',
    containsLowercase: 'Пароль повинен містити малу літеру',
    containsNumber: 'Пароль повинен містити цифру',
    containsSpecial: 'Пароль повинен містити спецсимвол (#?!@%^&*-)',
    email: 'Неправильний формат Email',
    emailExists: 'Така електронна адреса вже зареєстрована в системі',
  },
  quiz: {
    quiz: 'Опитування',
    startQuiz: 'Пройти опитування',
    selected: 'Відповідь обрали',
    results: 'Результати опитування',
    variant: 'Один з варіантів',
    publicResults: 'Результати',
    voting: 'Голосування',
    activeMessage: 'Активним може бути лише одне опитування',
    thankYou: 'Дякуємо за проходження опитування',
    statuses: {
      active: 'Активний',
      notActive: 'Неактивний',
    },
    peopleVote: 'Проголосувало 0 людей | Проголосувала {n} людина | Проголосували {n} людей | Проголосувала {n} людина',
    peopleSelected: 'Вибрало 0 людей | Вибрав {n} чоловік | Вибрали {n} людей | Вибрав {n} людина',
  },
  calendar: {
    birthdayDisabledText: 'Цей користувач встановив обмеження на надсилання привітань',
    toEvents: 'До подій',
    eventText: 'Подія',
    createEvent: 'Створення події',
    editEvent: 'Редагування події',
    removeEvent: 'Підтвердити видалення',
    removeEventAlert: 'Подія видалена',
    birthdays: 'Дні народження',
    units: 'Бізнес-юніти',
    year: 'Рік',
    month: 'Місяць',
    week: 'Тиждень',
    day: 'День',
    today: 'Сьогодні',
    none: 'Не повторюється',
    typeEvent: 'Захід',
    typeInfo: 'Інформаційне',
    showAllUsers: 'Показати всіх учасників',
    participating: 'Берете участь?',
    wantToJoin: 'Хочете взяти участь?',
    successJoinMessage: 'Запит на приєднання надіслано організатору',
    allParticipants: 'Усі учасники події',
    participant: '0 учасників | {n} учасник | Вибрали {n} учасника | Вибрав {n} учасник',
    // birthdayMan: '0 именинников | {n} именинник | Выбрали {n} именинника | Выбрал {n} именинников',
    birthdayMan: '0 іменинників | {n} іменинник | {n} іменинника | {n} іменинників',
    inputCongratulation: 'Введіть вітання',
    repeatAt: 'Повторювати кожну',
    onSuchDays: 'у такі дні:',
    congratulationWasSend: 'Привітання надіслано!',
    addToCalendar: 'Додати до календаря Outlook',
    birthdaySaved: 'День народження збережено!',
    event: {
      title: {
        label: 'Назва події',
        placeholder: 'Назва події',
      },
      startDate: {
        label: 'Дата старту події',
      },
      endDate: {
        label: 'Дата закінчення події',
      },
      periodicity: {
        label: 'Періодичність',
      },
      type: {
        label: 'Тип події',
      },
      link: {
        label: 'Посилання на подію',
      },
      users: {
        label: 'Учасники',
      },
      invited: {
        label: 'Запрошені',
      },
      description: {
        label: 'Опис',
        placeholder: 'Опис події',
      },
    },
    days: {
      monday: 'пн',
      tuesday: 'вт',
      wednesday: 'ср',
      thursday: 'чт',
      friday: 'пт',
      saturday: 'сб',
      sunday: 'нд',
    },
    finish: 'Завершити',
    repeatSettings: 'Налаштування повторення',
    organizer: 'Організатор',
  },
  ie: {
    header: 'На жаль, ваш браузер більше не підтримується',
    text: 'Для використання Інтранет-порталу IDS Ukraine встановіть інший браузер.',
  },
  knowledgeBase: {
    folderBase: 'папку',
    fileBase: 'файл',
    createFolder: 'Створення папки',
    editFolder: 'Редагування папки',
    toCreateFolder: 'Створити папку',
    toEditFolder: 'Редагувати папку',
    title: 'Назва',
    author: 'Автор',
    createdAt: 'Дата створення',
    size: 'Розмір',
    folder: {
      name: {
        label: 'Назва папки',
        placeholder: 'Введіть назву папки',
      },
      description: {
        label: 'Опис',
        placeholder: 'Введіть опис папки',
      },
      author: 'Автор',
      createdAt: 'Дата створення',
      size: 'Розмір',
    },
    emptyRootTitle: 'Сторінка "Документи" порожня',
    emptyRootDescription: 'Створіть папку',
    emptyTitle: 'Ця папка порожня',
    emptyDescription: 'Перетягніть файли у вікно, щоб завантажити їх.',
    uploadIcon: 'Завантажте іконку для папки',
  },
  bookmarks: {
    myLinks: 'Мої посилання',
    addLink: 'Додавання посилання',
    editLink: 'Редагування посилання',
    toAddLink: 'Додати посилання',
    link: {
      title: {
        label: 'Назва посилання',
        placeholder: 'Введіть назву посилання',
      },
      url: {
        label: 'URL - адреса',
        placeholder: 'http://',
      },
    },
  },
  policy: {
    h1: 'Правила користування порталом',
    p1: 'Дорогий колега, вітаємо тебе на',
    p1_1: 'Інтранет-порталі! ',
    p2: 'Тут ми, всі співробітники IDS Ukraine, можемо дізнаватись все про нашу Групу та її стратегію, ділитися новинами, отримувати доступ до актуальної інформації та сервісів, які допомагають у роботі.',
    p3: 'Заходячи на портал, ти погоджуєшся дотримуватися наступних правил:',
    li1: 'дотримуватися етики спілкування та поважати чужу думку;',
    li2: 'залишати за межами порталу обговорення гострих соціальних тем, особистих питань, включаючи гроші та здоров\'я;',
    li3: 'дотримуватися принципу прозорості та відсутності анонімності у публікації інформації;',
    li4: 'пам\'ятати про те, що портал призначений виключно для внутрішнього використання співробітників, тобто вміст є конфіденційним; ',
    li5: 'писати грамотно;',
    li6: 'бути готовим до того, що адміністрація порталу може відмовити в публікації або видалити контент на порталі, якщо він порушує будь-яке озвучене правило.',
    p4: 'На',
    p4_1: ' неприйнятно',
    li7: 'використовувати ненормативну лексику, грубі висловлювання, переходити на особи, ображати національні, релігійні та моральні почуття;',
    li8: 'публікувати свідомо неправдиву інформацію;',
    li9: 'публікувати посилання на неліцензійне комерційне програмне забезпечення, програми для його злому та генератори ключів, а також матеріали, захищені авторськими правами; ',
    li10: 'виступати в ролі модератора: робити зауваження іншим користувачам без відповідних повноважень;',
    li11: 'обговорювати та засуджувати дії користувачів, модераторів та адміністрації.',
    p5: 'За порушення правил адміністратори можуть винести попередження та заблокувати обліковий запис, але нам би цього не хотілося.',
    p6: 'З усіх технічних питань до IT Service Desk',
    p7: 'з питань контенту на Ask IDS Ukraine',
    p8: 'Нехай',
    p8_1: 'приносить тільки користь у роботі та комунікаціях!',
    p9: 'Команда внутрішніх комунікацій',
  },
}

export default locale
